export abstract class RadioGroupItem extends PIXI.Container {
    protected isSelected: boolean = false;

    public get selected() {
        return this.isSelected;
    }

    public setSelected(value: boolean) {
        this.isSelected = value;
    }
}
